import { Filter, FilterX } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/app/components/ui/dropdown-menu";
import { useDagStore } from "@/app/hooks/useDagStore";

interface TeamBadgeDropdownProps {
  team: string;
  className?: string;
}

export function TeamBadgeDropdown({ team, className = "" }: TeamBadgeDropdownProps) {
  const excludedTeams = useDagStore((state) => state.excludedTeams);
  const allTeams = useDagStore((state) => state.allTeams);
  const setExcludedTeams = useDagStore((state) => state.setExcludedTeams);

  const handleFilterByTeam = (e: Event) => {
    e.preventDefault();
    e.stopPropagation();
    // Set filters to show only this team
    const otherTeams = allTeams.filter((t) => t !== team);
    setExcludedTeams(otherTeams);
  };

  const handleFilterOutTeam = (e: Event) => {
    e.preventDefault();
    e.stopPropagation();
    // Add this team to excluded teams
    setExcludedTeams([...Array.from(excludedTeams), team]);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild onClick={(e) => e.stopPropagation()}>
        <button
          type="button"
          className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-stone-100 text-stone-700 hover:bg-stone-200 transition-colors ${className}`}
          onClick={(e) => e.stopPropagation()}
        >
          {team}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-48">
        <DropdownMenuItem onSelect={handleFilterByTeam}>
          <Filter className="w-4 h-4 mr-2" />
          Filter by this team
        </DropdownMenuItem>
        <DropdownMenuItem onSelect={handleFilterOutTeam}>
          <FilterX className="w-4 h-4 mr-2" />
          Filter out this team
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
